<template>
  <div class="loading-overlay">
    <div class="loading-pane">
      <div class="loading-location">
        <van-loading size=".2rem" color="#505050" text-color="#505050">加载中...</van-loading>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from 'vant'
export default {
  name: 'LoadingPane',
  components: {
    [Loading.name]: Loading
  }
}
</script>
<style scoped>
.loading-overlay, .loading-overlay .loading-pane{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
}
.loading-overlay{
  background-color: rgba(255, 255, 255, .5);
}
.loading-overlay .loading-pane{
  max-height: 100vh;
}
.loading-overlay .loading-pane .loading-location{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
}
</style>